import type { Campaign, CampaignStatus } from '../types/campaign'

export const CAMPAIGN_PAGE_VARIANT = 'yellow' as const

const STATUS_LABELS: Record<CampaignStatus, string> = {
  active: 'Em andamento',
  inactive: 'Indisponível',
  ended: 'Encerrada'
}

export function deriveCampaignStatus(
  campaign: Pick<Campaign, 'active' | 'ended'>
): CampaignStatus {
  if (campaign.ended) return 'ended'
  return campaign.active ? 'active' : 'inactive'
}

export function formatCampaignDate(value: string) {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '—'

  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  })
}

export function formatCampaignPeriod(startsAt: string, endsAt: string) {
  return `${formatCampaignDate(startsAt)} — ${formatCampaignDate(endsAt)}`
}

export function getDaysRemaining(endsAt: string) {
  const end = new Date(endsAt)
  const now = new Date()

  if (Number.isNaN(end.getTime())) return 0

  const diff = Math.ceil((end.getTime() - now.getTime()) / (1000 * 60 * 60 * 24))
  return Math.max(0, diff)
}

export function getCampaignStatusLabel(status: CampaignStatus) {
  return STATUS_LABELS[status] ?? status
}

export function getDaysRemainingLabel(endsAt: string, status: CampaignStatus) {
  if (status === 'ended') return 'Campanha encerrada'

  const days = getDaysRemaining(endsAt)
  if (days === 0) return 'Último dia'
  if (days === 1) return '1 dia restante'

  return `${days} dias restantes`
}
